import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import {
  getItemVolumetricInfoByDC,
  updateItemVolumetricInfoByDC
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import StatusModal from "../../common/StatusModal";

class ManageItemVolumetricInformationByDC extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  checkLength(weight) {
    var number = weight.toString();
    var decimals = number.split('.')[1];
    if(decimals) {
      if(decimals.length == 2) {
        return `${number}0`;
      } else if(decimals.length == 1) {
        return `${number}00`;
      }
    }    
  }
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = parseInt(this.state.lookup.item, 10).toString();
      getItemVolumetricInfoByDC(item, this.state.lookup.wse).then(res => {
        if (res.data.success) {
          msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
          //const whsesForItem = res.data.data.whsesForItem;
          const data = res.data.data;
          // delete data.whsesForItem;
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                // value: res.data.data.itemNumber,
                name: "itemNumber"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                value: res.data.data.lineCode /* */,
                name: "lineCode"
              },
              {
                label: "Part",
                value: res.data.data.partNumber,
                name: "partNumber"
              },
              {
                label: "Warehouse",
                //value: whsesForItem,
                name: "wse"
              },
              {
                label: "Shipment Rounding Factor",
                value: res.data.data.shipRoundFactor,
                name: "shipRoundFactor"
              },
              {
                label: "Shipment Flag",
                value: res.data.data.shipFlag,
                name: "shipFlag"
              },
              {
                label: "DC Cases Per Tier",
                value: res.data.data.unitsPerTier,
                name: "unitsPerTier"
              },
              {
                label: "DC Tiers Per Pallet",
                value: res.data.data.dctiersOnPallet,
                name: "dctiersOnPallet"
              },
              {
                label: "Master Strategy",
                value: res.data.data.masterStrategy /** */,
                name: "masterStrategy"
              },
              {
                label: "Modified Date",
                value: res.data.data.dateDimensionsCh /** */,
                name: "dateDimensionsCh"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "Unit Dimensions",
                    value: res.data.data.verifyDimensions,
                    name: "verifyDimensions"
                  },
                  {
                    label: "Unit Verified",
                    value: res.data.data.verifyDimensions /***/,
                    name: "unitVerified"
                  },
                  {
                    label: "Inner Verified",
                    value: res.data.data.innerValidFlag,
                    name: "innerValidFlag"
                  },
                  {
                    label: "Outer Verified",
                    value: res.data.data.outerValidFlag,
                    name: "outerValidFlag"
                  }
                ]
              },
              {
                card2: [
                  {
                    label: "Unit Weigth",
                    value: this.checkLength(res.data.data.singleUnitWeight),
                    name: "singleUnitWeight"
                  },
                  {
                    label: "Unit Height",
                    value: res.data.data.singleUnitHeight,
                    name: "singleUnitHeight"
                  },
                  {
                    label: "Unit Length",
                    value: res.data.data.singleUnitLength,
                    name: "singleUnitLength"
                  },
                  {
                    label: "Unit Cube",
                    value: res.data.data.unitCubicMeasure /** */,
                    name: "unitCubicMeasure"
                  },
                  {
                    label: "Unit Width",
                    value: res.data.data.singleUnitWidth,
                    name: "singleUnitWidth"
                  }
                ]
              },
              {
                Card3: [
                  {
                    label: "Inner Weight",
                    value: this.checkLength(res.data.data.innerWeight),
                    name: "innerWeight"
                  },
                  {
                    label: "Inner Height",
                    value: res.data.data.innerHeight,
                    name: "innerHeight"
                  },
                  {
                    label: "Inner Length",
                    value: res.data.data.innerLength,
                    name: "innerLength"
                  },
                  {
                    label: "Inner Quantity",
                    value: res.data.data.innerQty,
                    name: "innerQty"
                  },
                  {
                    label: "Inner Width",
                    value: res.data.data.innerWidth,
                    name: "innerWidth"
                  }
                ]
              },
              {
                Card4: [
                  {
                    label: "Outer Weight",
                    value: this.checkLength(res.data.data.outerWeight),
                    name: "outerWeight"
                  },
                  {
                    label: "Outer Height",
                    value: res.data.data.outerHeight,
                    name: "outerHeight"
                  },
                  {
                    label: "Outer Length",
                    value: res.data.data.outerLength,
                    name: "outerLength"
                  },
                  {
                    label: "Outer Cube",
                    value: res.data.data.outerCubicMeas,
                    name: "outerCubicMeas"
                  },
                  {
                    label: "Outer Width",
                    value: res.data.data.outerWidth,
                    name: "outerWidth"
                  },
                  {
                    label: "Outer Quantity",
                    value: res.data.data.outerQty,
                    name: "outerQty"
                  }
                ]
              }
            ]
          });
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please select an item number and a warehouse");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.itemNumber,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      // this.newInfo = {};
      this.newInfo.itemNumber = parseInt(this.newInfo.itemNumber, 10);
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };
  // save = () => {
  //   const formattedWhses = this.state.lookup.whses.map(wse => {
  //     return wse.toString();
  //   });
  //   this.setTransitioMessage(<Spinner msg="Saving..." />);
  // };

  save = () => {
    // this.setErrorMessage("Saving under construction");
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    var uId = sessionStorage.getItem("uId");
    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    updateItemVolumetricInfoByDC(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = {};
        setTimeout(() => {
          this.setSuccessMessage("Item was successfully updated");
        }, 1000);
        this.setState({ isSaveEnabled: false });
        this.lookup();
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };
  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item Volumetric Information By DC
        </h3>
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>

            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ManageItemVolumetricInformationByDC;
